import type { Dispatch, SetStateAction } from 'react'
import { useCallback, useRef, useState } from 'react'
import { useUnmountEffect } from './useUnmountEffect'

export function useRafState<S>(
  initialState: S | (() => S)
): [S, Dispatch<SetStateAction<S>>] {
  const frame = useRef(0)
  const [state, setState] = useState(initialState)

  const setRafState = useCallback((value: S | ((prevState: S) => S)) => {
    cancelAnimationFrame(frame.current)

    frame.current = requestAnimationFrame(() => {
      setState(value)
    })
  }, [])

  useUnmountEffect(() => {
    cancelAnimationFrame(frame.current)
  })

  return [state, setRafState]
}
